import { render, staticRenderFns } from "./RowsMixin.vue?vue&type=template&id=83e531c8&"
import script from "./RowsMixin.vue?vue&type=script&lang=js&"
export * from "./RowsMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports